export default "__VITE_ASSET__BTw4RtxA__"